import { LazyLoad } from '@petconsole/pure-fe-mui';

const VetAdmin = LazyLoad(() => import('./VetAdmin'));

export { VetAdmin };
